module.exports = __webpack_public_path__ + "static/media/Statua_056.2284bc4a.jpg";